import { render, staticRenderFns } from "./pacientes.vue?vue&type=template&id=1e4ce2d3&scoped=true&"
import script from "./pacientes.vue?vue&type=script&lang=js&"
export * from "./pacientes.vue?vue&type=script&lang=js&"
import style0 from "./pacientes.vue?vue&type=style&index=0&id=1e4ce2d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4ce2d3",
  null
  
)

export default component.exports